import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Sidebar from "./SideBar";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { useAuth } from "../Context/store/context";
import "./Mainlayout.css";


export function getRootPath(url) {
  const urlParts = url.split("/");
  return `/${urlParts[1]}`;
}

export default function MainLayout() {
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const { getToken, logoutuser } = useAuth();

  useEffect(() => {
    if (!getToken())
      logoutuser();
  }, []);

  const currentYear = new Date().getFullYear();

  return (
    <>
      {(userDetails) && (
        <div>
          <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
              <Sidebar />
              <div className="layout-page">
                <Navbar />
                <main>
                  <Outlet />
                </main>

                {/* Footer */}
                <footer className="content-footer footer bg-footer-theme">
                  <div className="footer-container d-flex align-items-center justify-content-between flex-md-row flex-column">
                    <div>
                      © {currentYear}, <a
                        href="https://ajsinnovations.in/"
                        className="text-primary"
                        target="_new"
                      >
                        AJS Innovations Pvt. Ltd.
                      </a> All Rights Reserved.
                    </div>
                    {/* <div>
                      © {currentYear}, <a
                        href="https://editpointindia.com/"
                        className="text-primary"
                        target="_new"
                      >
                        EditPoint India
                      </a> <span className="text-primary">& Invitd</span> All Rights Reserved.
                    </div> */}
                    {/* <div>
                      Developed By <a
                        href="https://ajsinnovations.in/"
                        className="text-primary"
                        target="_new"
                      >
                        AJS Innovations Pvt. Ltd.
                      </a>
                    </div> */}
                  </div>
                </footer>
                {/* / Footer */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
